import {DashboardStatisticsService} from './dashboard-statistics.service';
import {UserService} from './../../_services/user.service';
import {Component, OnInit} from '@angular/core';
import {Chart} from 'chart.js';
import {from} from 'rxjs';
import {PersonalInfoService} from '../personal-info/personal-info.service';
import {WorkExperienceService} from '../work-experience/work-experience.service';
import {EducationalInfoService} from '../educational-info/educational-info.service';
import {RefereeService} from '../referee/referee.service';
import {UploadsService} from '../uploads/uploads.service';

@Component({
  selector: 'app-dashboard-statistics',
  templateUrl: './dashboard-statistics.component.html',
  styleUrls: ['./dashboard-statistics.component.css']
})
export class DashboardStatisticsComponent implements OnInit {

  public profile: Array<{ name: string, completed: boolean, comment: string, items: number, createUrl: any }> = [];
  user: any;
  statistics: any;
  public profileCompleted = true;

  constructor(
    private userService: UserService,
    private dashboardStatisticsService: DashboardStatisticsService,
    private personalInfoService: PersonalInfoService,
    private workExperienceService: WorkExperienceService,
    private educationalInfoService: EducationalInfoService,
    private refereeService: RefereeService,
    private uploadsService: UploadsService
  ) {
  }

  ngOnInit(): void {

    this.getUser();
    this.getStatistics();
    this.checkProfileStrength();
  }

  getUser() {
    this.userService.getCurrentUser()
      .subscribe(response => {
        this.user = response;
      });
  }

  getStatistics() {
    this.dashboardStatisticsService.getStatistics()
      .subscribe(response => {
        this.statistics = response;
      });
  }

  checkProfileStrength() {
    this.personalInfoService.getPersonalInfo()
      .subscribe(response => {
        if (response) {
          this.profile.push({
            name: 'personal-information',
            completed: true,
            comment: 'Personal information has provided. You can edit any time.',
            items: 1,
            createUrl: '/dashboard/profile'
          });
        } else {
          this.profileCompleted = false;
          this.profile.push({
            name: 'personal-information',
            completed: false,
            comment: 'Personal information has not yet completed. Please provide the information.',
            items: 0,
            createUrl: '/dashboard/personal-info'
          });
        }
      });
    this.workExperienceService.getExperience()
      .subscribe(response => {
        if (response.length > 0) {
          this.profile.push({
            name: 'work-experience',
            completed: true,
            comment: 'Work experience information has provided. You can edit any time.',
            items: response.length,
            createUrl: '/dashboard/profile'
          });
        } else {
          this.profileCompleted = false;
          this.profile.push({
            name: 'work-experience',
            completed: false,
            comment: 'Work experience information has not yet completed. Please provide the information.',
            items: response.length,
            createUrl: '/dashboard/work-experience'
          });
        }
      });

    this.educationalInfoService.getEducationInfo()
      .subscribe(response => {
        if (response.length > 0) {
          this.profile.push({
            name: 'educational-information',
            completed: true,
            comment: 'Educational information has provided. You can edit any time.',
            items: response.length,
            createUrl: '/dashboard/profile'
          });
        } else {
          this.profileCompleted = false;
          this.profile.push({
            name: 'educational-information',
            completed: false,
            comment: 'Educational information has not yet completed. Please provide the information.',
            items: response.length,
            createUrl: '/dashboard/educational-info'
          });
        }
      });

    this.refereeService.getReferees()
      .subscribe(response => {
        if (response.length > 0) {
          this.profile.push({
            name: 'reference',
            completed: true,
            comment: 'Reference information has provided. You can edit any time.',
            items: response.length,
            createUrl: '/dashboard/profile'
          });
        } else {
          this.profileCompleted = false;
          this.profile.push({
            name: 'reference',
            completed: false,
            comment: 'Reference information has not yet completed. Please provide the information.',
            items: response.length,
            createUrl: '/dashboard/referee'
          });
        }
      });

    this.uploadsService.getUploads()
      .subscribe(response => {
        if (response.length > 0) {
          this.profile.push({
            name: 'uploads',
            completed: true,
            comment: 'Attached files has provided. You can edit any time.',
            items: response.length,
            createUrl: '/dashboard/profile'
          });
        } else {
          this.profileCompleted = false;
          this.profile.push({
            name: 'uploads',
            completed: false,
            comment: 'There are no attached files. Please provide the information.',
            items: response.length,
            createUrl: '/dashboard/uploads'
          });
        }
      });
  }


}
